import React, { Component } from 'react';
import {Button, Table, Modal, FormGroup, Col } from 'reactstrap';
import { connect } from "react-redux";
import ErrorGif from 'Assets/images/Error.gif';
import 'Assets/Reports/greenTable.css';
import 'Assets/Reports/reportsDefinitions.css';
import SelectAllCheckboxes from 'Resources/SelectAllCheckboxes';
import { DownloadSelectedReport, DeleteArtifacts, EmailSelectedArtifacts} from 'action/ReportManagement/ManageReports';
import classnames from 'classnames';

let Email = "^(([a-zA-Z0-9]|[!#$%&'*+/=?^_`{|}~-])[\\.]?)*([a-zA-Z0-9]+[!#$%&'*+/=?^_`{|}~-]*|[a-zA-Z0-9]*[!#$%&'*+/=?^_`{|}~-]+)[@]{1}([a-zA-Z0-9_-]*([\\.]?[a-zA-Z0-9_]+)+)$";
var displayMsg;

class ViewRunHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal_close: false,
            deleteModal: false,
            selectionMsg:false,
            error_msg: false,
            reportName: '',
            reportId: '',
            subject: true,
            selectedArtifacts: [],
            emailModal: false,
            toVal: '',
            ccVal: '',
            subjVal: '',
            msgVal: '',
            disableButton: false,
            disableDltButton: false,
            appendExcelInstances: 0
        };

         this.closeWindow = this.closeWindow.bind(this);
         this.toggleDelete = this.toggleDelete.bind(this);
         this.toggleEmailArtifacts = this.toggleEmailArtifacts.bind(this);        
        }
    


    componentDidUpdate(nextProps){
        if (this.props.getReportsSubList !== nextProps.getReportsSubList){
            if (this.props.getReportsSubList.length !== 0 && Array.isArray(this.props.getReportsSubList))  {
                this.setState({
                    disableButton:false,
                    disableDltButton: false,
                    multiSelectionMsg:false,

                })
            }else{
                this.setState({
                    disableButton:true,
                    disableDltButton: true
                })
            }
        }
    }

    closeWindow() {  this.props.viewrunhistory_toggle();  }
    toggleDelete() { 
        this.setState({deleteModal: !this.state.deleteModal}); 
    }

    toggleEmailArtifacts() { 
        if (this.state.selectedArtifacts.length > 0) {
            this.setState({error_msg: false});
            this.setState({emailModal: !this.state.emailModal}); 
            this.setState({subjVal: this.props.parentToChildData[0]});

            if (this.state.emailModal) {
                this.uncheckValues();
                SelectAllCheckboxes.ResetHeaderCheckBox("runHistory_checkbox", "header_check_box"); 
            }
        } else {
            this.setState({error_msg: true});
        }
    }

    setReportName() {
        if (this.props.parentToChildData && this.props.parentToChildData.length > 1) {
            this.setState({reportName: this.props.parentToChildData[0]});
            this.setState({reportId: this.props.parentToChildData[1]});
        }  
    }

    downloadReport(artifactFileName, fileFormat){
        var rptName = this.state.reportName === '' && this.props.parentToChildData.length > 0 ? this.props.parentToChildData[0] : this.state.reportName;
        var ext = fileFormat.toLowerCase() === 'excel' ? 'xlsx' : fileFormat.toLowerCase();
        var downloadName = rptName + "." + ext;
        this.props.DownloadSelectedReport(artifactFileName, downloadName);
    }

    Delete = (arg) => {
        if (arg === "yes") {
            var rptId = this.state.reportId === '' && this.props.parentToChildData.length > 0 ? this.props.parentToChildData[1] : this.state.reportId;
            SelectAllCheckboxes.ResetHeaderCheckBox("runHistory_checkbox", "header_check_box");
            var Data = [];
            var ckboxes = document.getElementsByClassName('runHistory_checkbox');
  
            for (var itm of ckboxes) {
              if (itm.checked) {
                var fdn = this.getArtifactInfo(itm.id);
                if (fdn){
                    if (!fdn.usedInFutureSchedule) {
                        Data.push(itm.id);
                    }
                }
              }
            }
  
            if (Data.length > 0) {
              this.props.DeleteArtifacts(rptId, Data);
            }
            
            this.toggleDelete();
            this.uncheckValues();
        }
        else {
            this.toggleDelete();
        }
    }

    setAllSelected= () => {
        SelectAllCheckboxes.selectAllCheckbox("runHistory_checkbox", "header_check_box"); 
        this.setSelectedArtifacts();
    }

    setSelectedArtifacts = () => {
        var ckboxes = document.getElementsByClassName('runHistory_checkbox');
        var selectedItems = [];
        var selectedFileExist = [];
        this.setState({appendExcelInstances: 0});
        var updatedCt = 0;
        
        if (ckboxes.length > 0) {
            for (var itm of ckboxes) {
                if (itm.checked) {
                    var fdn = this.getArtifactInfo(itm.id);
                    if (fdn){
                        selectedFileExist.push(fdn.fileExists);
                        selectedItems.push(fdn);

                        if (fdn.usedInFutureSchedule && fdn.appendExcel) {
                            updatedCt++;
                        }
                    };                    
                }

                this.setState({appendExcelInstances: updatedCt});              
                this.setState({ selectedArtifacts: selectedItems});
                SelectAllCheckboxes.ResetHeaderCheckBox("runHistory_checkbox", "header_check_box"); 
            }
            
            /***Added this new logic to the check event handling function to evaluate the fileExist value to 
             * either disable or show a message indicating that the user 
             * selected more then one or more report that does not exist. We also set the mnessage state when the user hits the send email button
            **/
           console.log(selectedFileExist);

            if (selectedFileExist.length > 1) {
               if (selectedFileExist.includes(false) && selectedFileExist.includes(true)) { 
                      displayMsg = true
                   this.setState({
                       selectionMsg:true,
                       disableButton:false,
                       disableDltButton: false,
                    });
               } else if (selectedFileExist.every(v => v === false)) {        
                    displayMsg = false
                         
                    this.setState({
                        selectionMsg:false,
                        disableButton:true,
                        disableDltButton: false
                    });
                }else if (selectedFileExist.every(v => v === true)){
                    displayMsg = false                          
                    this.setState({
                        selectionMsg:false,
                        disableButton:false,
                        disableDltButton: false
                    }); 
                }
            }else if (selectedFileExist.length === 1){
                if (selectedFileExist.includes(false)) { 
                    displayMsg = false
                                           
                    this.setState({
                        selectionMsg:false,
                        disableButton:true,
                        disableDltButton: false
                    });
                }else if (selectedFileExist.includes(true)){
                    displayMsg = false
                          
                    this.setState({
                        selectionMsg:false,
                        disableButton:false,
                        disableDltButton: false
                    });
                }
            }

        }
    }

    getArtifactInfo(selId) {
        if (!isNaN(selId))
        return this.props.getReportsSubList.find(({id}) => id === parseInt(selId));
    }

    uncheckValues() {
        var ckboxes = document.getElementsByClassName('runHistory_checkbox');
        for (var itm of ckboxes) {
            if (itm.checked) {
            itm.checked = false;
            }
        }
    }

    // email functions
    clearEmailForm() {
        this.setState({toVal: ''});
        this.setState({ccVal: ''});
        this.setState({subjVal: ''});
        this.setState({msgVal: ''});
    }

    clearSubjectArea() {
        if (this.state.reportName === '')
            this.setReportName();

        var sVal =  document.getElementById('useAsSubject').checked === true ? this.state.reportName : '';
        this.setState({subjVal: sVal});
    }

    hideErrorMessages() {
        var msgs = document.getElementsByClassName('RM_errorMessage');
        if (msgs) {
            for (let msg of msgs) {
                if (msg.id !== 'noneSelected')
                    msg.style.display = 'none';
            }
        }
    }

    getArtifactIds(artifactList) {
        if (artifactList.length > 0) {
        return Array.prototype.map.call(artifactList, function(art) {
            return art.id;
          })
        }
        return [];
    }

    onFieldChange(e) {
        this.setState({[e.target.name]: e.target.value});
   }

    SendArtifactEmail = () => {
        var rptId = this.state.reportId === '' && this.props.parentToChildData.length > 0 ? this.props.parentToChildData[1] : this.state.reportId;
        var rptName = this.state.reportName === '' && this.props.parentToChildData.length > 0 ? this.props.parentToChildData[0] : this.state.reportName;
        var success = this.ValidateArtifactEmail();
        document.getElementById('recipientErrorMsg').style.display = success ? 'none' : 'initial';
        
        if (success) {
            var toVal = this.state.toVal.trim();
            var ccVal = this.state.ccVal.trim(); 
            var subjVal = this.state.subjVal !== '' ? this.state.subjVal : rptName; 
            var msgVal = this.state.msgVal; 
            var allAddresses = toVal + '|' + ccVal;

            var artifactEmailInfo = {
                "EmailAddresses": allAddresses,
                "EmailContent": msgVal,
                "EmailSubject": subjVal,
                "FileInfo": this.getArtifactIds(this.state.selectedArtifacts)
            }
            
            this.props.EmailSelectedArtifacts(rptId, artifactEmailInfo);
            this.toggleEmailArtifacts();
            this.clearEmailForm();
        } 
    }

    ValidateArtifactEmail = () => {
        var success = true;
        var toVal = this.state.toVal; 
        var ccVal = this.state.ccVal;

        if (toVal === '') { // to values are required; cc values are not
            success = false;
        } else {
            var tos = toVal.split(';');
            if(tos.length > 0){
                tos.forEach(to => {
                    if (to.trim() !== '' && !to.trim().match(Email))
                        success = false;
                });
            }

            if (ccVal !== '') { // if we have them, they should be valid
                var ccs = ccVal.split(';');
                if(ccs.length > 0){
                    ccs.forEach(cc => {
                        if(cc.trim() !== '' && !cc.trim().match(Email))
                            success = false;
                    });
                }
            }
        }
        return success;
    }

    setDeleteConfirmationText = () => {
        var confirmationLabel = "";
        var label = this.props.getLabels;
        var hasLabels = label && label !== null;

        if (this.state.selectedArtifacts.length > 0) {
            if (this.state.appendExcelInstances > 0 && hasLabels) {
                var allSelected = this.state.selectedArtifacts.length === this.state.appendExcelInstances;
                confirmationLabel = allSelected? label['DeleteArtifactConfirmationAllExcelCannotBeDeleted.Text'] : label['DeleteArtifactConfirmationExcelCannotBeDeleted.Text'] ;
            } else if (hasLabels && label['DeleteArtifactConfirmation.Text'] !== undefined) {
                confirmationLabel = label['DeleteArtifactConfirmation.Text'];
            } else {
                confirmationLabel = "You are about to delete one or more generated reports. Do you want to continue?";
            }
        } else {
            confirmationLabel = hasLabels ? label['DeleteArtifactNoFiles.Text'] : "No files were selected for deletion.";
        }

        return confirmationLabel;
    }

    // end email functions

    render(userHasFullaccess) {
        var label = this.props.getLabels;
        var tbody_data, tbody_artifact = null;
        var rptName = this.props.parentToChildData[0];
        var disableCheckbox = false;

        let hasFullaccess = this.props.userHasFullaccess;
         hasFullaccess = hasFullaccess !== undefined && hasFullaccess !== null && hasFullaccess ? true : false;
    
        if (this.props.getReportsSubList.length !== 0 && Array.isArray(this.props.getReportsSubList))  {
            tbody_data = this.props.getReportsSubList.map(el => (
                <tr key={el.id}>
                    <td style={border_color}>
                        <span>
                            <input type="checkbox" id={el.id} className="runHistory_checkbox" onClick={() => { this.setSelectedArtifacts() }} style={{float:'left',marginRight:'3px'}} /> 
                            {el.fileExists ?
                            <p style={{ color: '#6890C6' }} onClick={() => { this.downloadReport(el.fileName, el.outputType) }} className="link_cursor">{el.runTimeDateTimeString}</p>
                            : <p>{el.runTimeDateTimeString}</p>}
                        </span>  
                    </td>
                    <td style={border_color}>{el.runType}</td>
                    <td style={border_color}>{el.outputType === "EXCEL" ? "Excel": el.outputType}</td>
                </tr>
            ));
        }
        else{
            tbody_data = <tr><td colSpan="5">{label['NoRecordsFound.Text']}</td></tr>;
            disableCheckbox = true;
        }

        if (this.state.selectedArtifacts.length !== 0)  {
            
            tbody_artifact = this.state.selectedArtifacts.map((el)=>{
           return( el.fileExists === true && <tr key={el.id}>
                    <td style={border_color}>{el.runTimeDateTimeString}</td>
                    <td style={border_color}>{el.runType}</td>
                    <td style={border_color}>{el.outputType}</td>
                </tr>)  
            }
            );
        } else {
            tbody_artifact = <tr><td colSpan="5">{label['NoRecordsFound.Text']}</td></tr>;
        }
   
        return (
            <div style={{lineHeight: '20px'}}>
                <div style={modal_title}>{(label['ReportName.Text'] !== undefined ? label['ReportName.Text'] : "Report Name") + ': ' + rptName}</div>
                <div id='runHistory' style={{display: this.state.emailModal ? 'none' : 'initial'}}>
                    <div style={{lineHeight: '12px', height: '50px'}}>
                        <div style={modal_sub_title_withErrors}>{label['ReportHistory.Text'] !== undefined ? label['ReportHistory.Text'] : "Report History"}</div>
                        <span id='noneSelected' className='RM_errorMessage' style={{display: this.state.error_msg === true ? 'initial' : 'none'}}><img src={ErrorGif} alt="Error" />{label['ErrorSelectOneOrMore.Text'] !== undefined ? label['ErrorSelectOneOrMore.Text'] : "Error: Select one or more records to perform this action."}</span>
                        <span id='noFile' className='RM_errorMessage' style={{display: 'none'}}><img src={ErrorGif} alt="Error" />{label['FileDoesNotExist.Text'] !== undefined ? label['FileDoesNotExist.Text'] : "The file referenced no longer exists."}</span>
                        <span id='noEmail'  className='RM_errorMessage' style={{display: 'none'}}><img src={ErrorGif} alt="Error" />{label['UnableToSendEmail.Text'] !== undefined ? label['UnableToSendEmail.Text'] : "Error: unable to send email."}</span>
                    </div>
                
                    <div className="table_container" style={viewrunhistory_table}>
                        <div id='emailSuccess'  className='RM_errorMessage' style={{display: 'none', color:'#2070CF', fontStyle: 'italic'}}>{label['EmailSuccessfullySent.Text'] !== undefined ? label['EmailSuccessfullySent.Text'] : "Email successfully sent!"}</div>
                        <Table responsive className="customised_green_table">
                            <thead>
                                <tr>
                                    <th className="link_cursor" style={border_color} width="45%"><span><input type="checkbox" id="header_checkbox" disabled={disableCheckbox} className="header_check_box" onClick={() => { this.setAllSelected() }} style={{float:'left',marginRight:'3px'}} />{label['RunDateTime.Text'] !== undefined ? label['RunDateTime.Text'] : "Run Date and Time"}</span> </th>
                                    <th className="link_cursor" style={border_color} width="15%">{label['RunType.Text'] !== undefined ? label['RunType.Text'] : "Run Type"} </th>
                                    <th className="link_cursor" style={border_color} width="40%">{label['Format.Text'] !== undefined ? label['Format.Text'] : "Format"}  </th>
                                </tr>
                            </thead>
                            <tbody>
                                {tbody_data}
                            </tbody>
                        </Table>
                    </div>
                    <div>
                        <Button color="link" onClick={this.closeWindow}style={{color:'#6C97BF'}}  > {"Close"} </Button>
                        <Button className="btn-success btn-md" disabled={this.state.disableButton} onClick={this.reportActions('mail_record')}  style={{float:'right', marginRight: '0px'}}>{label['SendEmail.Text'] !== undefined ? label['SendEmail.Text'] : "Send Email"}</Button>
                        <Button className="btn-gray btn-md" disabled={this.state.disableDltButton} hidden={!hasFullaccess} onClick={this.reportActions('delete_record')} style={{float:'right',marginRight:'10px'}} > {label['ManageSavedReports.btnDelete.Text'] !== undefined ? label['ManageSavedReports.btnDelete.Text'] : "Delete"} </Button>
                    </div>

                    <Modal isOpen={this.state.deleteModal} deletemodal={this.deleteModal} className={classnames({ classnames: this.props.className }, "RM_ModalContainer")} >
                        <div className="delete_confirmation_Modal">
                            <h4 id="title_Delete" className="Modal_form_title">  {[label['Delete.Text']]}</h4>
                            <div id="txt_Delete_UAText" className="delete_msg_content">
                                {this.setDeleteConfirmationText()}
                            </div>

                            <FormGroup row >
                                <Col sm={{ size: 12 }}>
                                    <Button id="btn_NoDelete" className="btn-gray btn-md" onClick={() => this.Delete('Cancel')}>{label['ReportManagement.No.Text'] !== undefined ?label['ReportManagement.No.Text'] : "No" }</Button>
                                    <Button id="btn_YesDelete" className="btn-success btn-md" disabled={this.state.selectedArtifacts.length === this.state.appendExcelInstances} onClick={() => this.Delete('yes')}> {label['ReportManagement.YesDelete.Text=Yes']!== undefined ? label['ReportManagement.YesDelete.Text=Yes'] : "Yes, Delete"} </Button>
                            
                                </Col>
                            </FormGroup>
                        </div>
         
                    </Modal>
                </div>

        
                <div id='emailForm' style={{lineHeight: '12px', display: this.state.emailModal ? 'initial' : 'none'}}>
                    <div style={{lineHeight: '12px', height: '50px'}}>
                        <div style={modal_sub_title_withErrors}>{label['ReportHistory.Text']}</div>
                        <span id='recipientErrorMsg' className='RM_errorMessage' style={{display:'none'}}><img src={ErrorGif} alt="Error" />{label['EmailRecipientError.Text'] !== undefined ? label['EmailRecipientError.Text'] : "Error: Recipient field is empty, is not a known name or is not in the correct e-mail address format."}</span>
                        <span id='sendEmailErrorMsg' className='RM_errorMessage' style={{display:'none'}}><img src={ErrorGif} alt="Error" />{label['SendEmailError.Text'] !== undefined ? label['SendEmailError.Text'] : "An error was encountered during sending of the email."}</span>
                        <span id='multiReportErrorMsg' className='RM_errorMultiMessage' style={{display: this.state.selectionMsg === true ? 'initial' : 'none'}}><img src={ErrorGif} alt="Error" />{label['MultiReportError.Text'] !== undefined ? label['MultiReportError.Text'] : "One or more records selected does not have a report file saved to Tracer Ensemble. Only the file(s) listed in Atachments will be emailed."}</span>
                    </div>

                    <div style={{marginTop: this.state.selectionMsg === true ? '10px' : '0px'}}>
                        <div className="inline15" style={blackButton} ><span>{label['ManageReportSchedule.lblEmailToRecipient.Text'] !== undefined ? label['ManageReportSchedule.lblEmailToRecipient.Text'] : "To:"}</span></div>
                        <div className="inline80"><textarea id="toValue" name='toVal' style={emailTextArea} rows={4} value={this.state.toVal} onChange={(value) => this.onFieldChange(value)}  /></div>
                        <div className="inline15"></div>
                        <div  className="inline80" style={{marginBottom: '10px', marginTop: '5px', lineHeight: '12px'}}>{label['ManageReportSchedule.lblEmailRecipientUAText.Text'] !== undefined ? label['ManageReportSchedule.lblEmailRecipientUAText.Text'] : "\"Use semi-colons to separate names. Eg: name1@company.com; name2@company.com\""}</div>
                    </div>
                    <div style={{marginBottom: '10px'}}> 
                        <div className="inline15" style={blackButton}><span>{label['ManageReportSchedule.lblEmailCcRecipient.Text'] !== undefined ? label['ManageReportSchedule.lblEmailCcRecipient.Text'] : "Cc:"}</span></div>
                        <div className="inline80"><textarea id="ccValue" name='ccVal' style={emailTextArea} rows={4} value={this.state.ccVal} onChange={(value) => this.onFieldChange(value)} /></div>
                    </div>
                    <div>
                        <div className="inline15">{label['ManageReportSchedule.lblEmailSubject.Text']}</div>
                        <div className="inline80"><input type="text" id="subjectValue" name='subjVal' className="default-input Modal_input_textbelow" value={this.state.subjVal} onChange={(value) => this.onFieldChange(value)} /></div>
                        <div className="inline15"></div>
                        <div className="inline80" style={{marginBottom: '10px', marginTop:'5px', lineHeight: '12px'}}>
                            <input type="checkbox" id='useAsSubject' defaultChecked onChange={() => { this.clearSubjectArea() }} style={{float:'left',marginRight:'3px'}} /> 
                            {label['UseReportNameAsSubject.Text']}
                        </div>
                    </div>
                    <div style={{marginBottom: '10px'}}>
                        <div className="inline15">{ label['ManageReportSchedule.lblEmailMessage.Text'] }</div>
                        <div className="inline80"><textarea id="msgValue" name='msgVal' style={emailTextArea} rows={5} value={this.state.msgVal} onChange={(value) => this.onFieldChange(value)} /></div>
                    </div>
                    <div className="table_container">
                        <div style={modal_sub_title_noMargin}>{label['SetUpReportEmail.lblAttachment.Text']}</div>
                        <div style={{height: '145px', overflow: 'auto'}}>
                            <Table responsive className="customised_green_table">
                                <thead>
                                    <tr>
                                        <th style={border_color} width="50%">{label['RunDateTime.Text']}</th>
                                        <th style={border_color} width="25%">{label['RunType.Text']}</th>
                                        <th style={border_color} width="25%">{label['Format.Text']}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tbody_artifact}
                                </tbody>
                            </Table>
                        </div>
                    </div>

                    <div style={{textAlign:'right', marginTop: '10px'}}>
                            <Button className="btn-gray btn-md" onClick={this.toggleEmailArtifacts} style={{marginRight:'10px'}} > {label['Buttons.Cancel.Text']} </Button>
                            <Button className="btn-success btn-md" style={{marginRight:'0px'}} onClick={() => { this.SendArtifactEmail() }} >{label['Buttons.Send.Text']}</Button>
                    </div>    
                </div>
            </div>
        );
    }
   
    reportActions = (action_type) => (e) => { 
        var Data = [];
        var checkboxes = document.getElementsByClassName('runHistory_checkbox');
        this.hideErrorMessages();
        
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                var reports_checked= {
                    "reports_id": checkboxes[i].id
                }
                Data.push(reports_checked);
            }
        }

        if (Data.length > 0) {
            this.setState({ error_msg: false });

            if(action_type==="delete_record"){
                this.toggleDelete();
            }
            else if(action_type==="mail_record"){

                    this.setState({
                        selectionMsg:displayMsg
                    })
                this.toggleEmailArtifacts();
            }
        }
        else {
            this.setState({ error_msg: true });
        }
    }
    
}


const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.ReportMgmt_LabelsBasedOnPreference,
        getReportsSubList: state.ManageReportsSubListRootReducer.MangeReportsSublist,
        userHasFullaccess: state.authService.HasApplicationFullAcess,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        DownloadSelectedReport: (artifactFileName, downloadName) => dispatch(DownloadSelectedReport(artifactFileName, downloadName)),
        DeleteArtifacts: (reportId, data) => dispatch(DeleteArtifacts(reportId, data)),
        EmailSelectedArtifacts: (reportId, artifactEmailInfo) => dispatch(EmailSelectedArtifacts(reportId, artifactEmailInfo))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewRunHistory);


// Component Styles
        const border_color = {
            borderRight: '1px solid #ededed'
        }

        const modal_title ={
            fontFamily:'Arial-BoldMT,Arial Bold, Arial',
            fontWeight:700,
            fontSize: '18px',
            textAlign: 'left'
        }

        const modal_sub_title_withErrors={
            marginBottom:'5px',
            marginTop: '5px',
            fontSize: '15px'
        };
        
        const modal_sub_title_noMargin={
            fontSize: '1.1em',
            fontWeight: 'bold',
            paddingBottom: '5px',
            lineHeight: '12px'
        };
        
        const viewrunhistory_table={
            height: '460px',
            overflowY: 'auto',
            marginBottom:'10px',
            
        }
        const blackButton = {
            backgroundColor: 'black', 
            padding:'5px', 
            color: 'white',
            textAlign: 'center'
        }
        
        const emailTextArea = {
            width: '100%', 
            resize: 'none',
            fontSize: '13px',
            overflowX: 'hidden' // needed for Firefox
        }
//End of  Component Styles
  
  
  
  




